<template>
  <div class="classic-form-page">
    <mdb-navbar
      navStyle="background-color: transparent;"
      position="top"
      dark
      transparent
    >
      
      <mdb-navbar-toggler>
        <mdb-navbar-nav>
          <mdb-nav-item href="https://bndbs.ir" waves-fixed active>صفحه اصلی</mdb-nav-item>
          <mdb-nav-item href="https://bndbs.ir/%D8%AA%D9%85%D8%A7%D8%B3-%D8%A8%D8%A7-%D8%B4%D8%B1%DA%A9%D8%AA-%D8%A8%D8%B1%D9%86%D8%A7%D9%85%D9%87-%D9%86%D9%88%DB%8C%D8%B3%D8%A7%D9%86-%D8%AF%D8%A7%D9%86%D8%B4-%D8%A8%D8%B1%D8%AA%D8%B1-%D8%B3%D9%87%D9%86%D8%AF" waves-fixed>تماس باما</mdb-nav-item>
        </mdb-navbar-nav>
      </mdb-navbar-toggler>

      <mdb-navbar-brand class="right-nav" href="https://client.bndbs.ir"><strong>پنل کاربری شرکت  برنامه نویسان</strong></mdb-navbar-brand>
      
    </mdb-navbar>

    <mdb-view>
      <mdb-mask
        overlay="stylish-strong"
        class="d-flex justify-content-center align-items-center"
      >
        <mdb-container>
          <mdb-row>
            <div class="col-xl-5 col-lg-6 col-md-10 col-sm-12 mx-auto mt-5">
              <mdb-card id="classic-card">
                <mdb-card-body class="z-depth-2 white-text">
                  <div class="form-header purple-gradient">
                    <h3>تنظیم رمز عبور <i class="fas fa-user mt-2 mb-2"></i></h3>
                  </div>
                  <ValidationObserver v-slot="{ invalid }">
                       
                    <ValidationProvider v-slot="{ errors }" name="Code" rules="required|min_value:000111|max_value:999999">
                      <mdb-input
                        label="لطفا کد پیامک شده را وارد نمایید"
                        labelColor="white"
                        icon="mobile"
                        v-model="form.Code"
                        :error-messages="errors"
                        class="req v-input--is-label-active"
                      />
                      <a @click="resend()" class="resend">
                        <span v-show="timerCount != 0" v-text="timerCount"></span>
                        <span v-show="timerCount == 0" title="ارسال دورباره">
                          <mdb-icon fa icon="comment" />
                        </span>
                      </a>
                      
                      
                    </ValidationProvider>

                    <ValidationProvider v-slot="{ errors }" name="Password" rules="required">
                      <mdb-input
                        label="لطفا رمز عبور دلخواه خودتان را وارد کنید"
                        labelColor="white"
                        icon="lock"
                        :type="passwordVisible ? 'text' : 'password'"
                        v-model="form.Password"
                        :error-messages="errors"
                        @keyup.enter="passwordEnter"
                        class="req v-input--is-label-active"
                        @click:append="passwordVisible = !passwordVisible"
                        :append-icon="passwordVisible ? 'far fa-eye' : 'far fa-eye-slash'"
                      />
                      
                      
                    </ValidationProvider>


                    <ValidationProvider v-slot="{ errors }" name="ConfirmPassword" rules="required">
                      <mdb-input
                        label="تکرار رمز عبور دلخواه خودتان را وارد کنید"
                        labelColor="white"
                        icon="lock"
                        :type="passwordVisible ? 'text' : 'password'"
                        v-model="form.ConfirmPassword"
                        :error-messages="errors"
                        @keyup.enter="passwordEnter"
                        class="req v-input--is-label-active"
                        @click:append="passwordVisible = !passwordVisible"
                        :append-icon="passwordVisible ? 'far fa-eye' : 'far fa-eye-slash'"
                      />
                      
                      
                    </ValidationProvider>

                    <ValidationProvider v-slot="{ errors }" name="Captch" rules="required">
                      <div class="row">
                        <div class="col-4"></div>
                        <img alt="captcha" :src="form.CaptchaImgUrl"
                          style="margin-bottom: 4px;">
                      <a class="fas fa-refresh btn-sm" style="cursor: pointer"
                        name="dntCaptchaRefreshButton" @click="doRefresh()"></a>
                      </div>
                      <mdb-input
                        label="لطفا حاصل جمع اعداد بالا را وارد کنید"
                        labelColor="white"
                        icon="robot"
                        v-model="form.CaptchaInputText"
                        :error-messages="errors"
                        class="req v-input--is-label-active"
                      />
                      
                      
                      
                    </ValidationProvider>

                    <div v-show="message!==null" class="alert alert-danger" v-html="message">
                    </div>



                    <div class="text-center mt-4 black-text">    
                      <div v-show="message!==null" class="alert alert-danger">
                        {{message}}
                      </div>

                      <mdb-btn gradient="purple" color="primary" class="mr-4" 
                        :disabled="invalid" 
                        @click="confirm" 
                        :loading="posting">ثبت</mdb-btn>
                      
                      <hr />
                      <div
                        class="text-center d-flex justify-content-center white-label"
                      >
                        <a class="p-2 m-2" href="https://www.twitter.com/bndbs_ir/">
                          <mdb-icon fab icon="twitter" class="white-text" />
                        </a>
                        <a class="p-2 m-2" href="https://www.linkedin.com/company/bndbs">
                          <mdb-icon fab icon="linkedin" class="white-text" />
                        </a>
                        <a class="p-2 m-2" href="https://www.instagram.com/bndbs_ir/">
                          <mdb-icon fab icon="instagram" class="white-text" />
                        </a>
                      </div>
                    </div>
                  </ValidationObserver>
                </mdb-card-body>
              </mdb-card>
            </div>
          </mdb-row>
        </mdb-container>
      </mdb-mask>
    </mdb-view>
  </div>
</template>

<script>
import {
  mdbView,
  mdbMask,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbInput,
  mdbIcon,
  mdbNavbarBrand,
  mdbNavbar,
  mdbNavbarToggler,
  mdbNavbarNav,
  mdbNavItem,
  mdbContainer,
  mdbRow,
} from "mdbvue";

import accountApi from "@/api/accountApi";
import { actionTypes } from "@/store-types";

export default {
  name: "confirm",
  components: {
    mdbView,
    mdbMask,
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbInput,
    mdbIcon,
    mdbNavbarBrand,
    mdbNavbar,
    mdbNavbarToggler,
    mdbNavbarNav,
    mdbNavItem,
    mdbContainer,
    mdbRow,
  },
  data() {
    return {
      posting: false,
      timerCount: 60,
      form: {
        UserId: null,
        Password: null,
        ConfirmPassword: null,
        Code: null,

        CaptchaInputText: null,
        CaptchaImgUrl: null,
        CaptchaId: null,
        CaptchaText: null,
        CaptchaToken: null,
      },
      message: null,
      passwordVisible: false,
    };
  },
  methods: {
    confirm() {
      this.posting = true;
      this.message = null;
    //   console.log('form',this.form);

      accountApi.confirm(this.form).then(
        ({ data }) => {
          if (data.Status === 1) {
            this.posting = false;
            this.$router.push({name: 'UserLogin'});
          } else {
            this.doRefresh();
            this.message = data.Message;
            this.posting = false;
          }
        },
        (r) => {
            this.doRefresh();
          var message = r.response.data.errors;
          this.posting = false;
          console.log("r", r.response.data);

         this.message ="";
          if(message.hasOwnProperty("UserId")){
            this.message +='<br>'+ message.UserId;
          }

          if(message.hasOwnProperty("Password")){
            this.message +='<br>'+ message.Password;
          }

          if(message.hasOwnProperty("ConfirmPassword")){
            this.message +='<br>'+ message.ConfirmPassword;
          }
          
          if(message.hasOwnProperty("Code")){
            this.message +='<br>'+ message.Code;
          }

        }
      );
    },
    doRefresh(){
      const vueThis = this;
      accountApi.captcha().then(
        ({ data }) => {
        //   console.log(data.CaptchaImgUrl);
          // this.from.CaptchaInputText = data.CaptchaInputText;
          vueThis.form.CaptchaImgUrl = data.CaptchaImgUrl;
          vueThis.form.CaptchaId = data.CaptchaId;
          vueThis.form.CaptchaText = data.CaptchaTextValue;
          vueThis.form.CaptchaToken = data.CaptchaTokenValue;

        },
        (r) => {
          vueThis.posting = true;
          console.log("r", r.response.data);
        }
      );
    },
    resend(){
      const vueThis = this;
      if(vueThis.timerCount == 0){
        accountApi.resendCode({
          UserId:this.form.UserId
        }).then(
          ({ data }) => {
            if(data.Status == 1){
              vueThis.timerCount = 60;
            }else{
              vueThis.message = data.Message;
            }
          },
          (r) => {
            vueThis.posting = true;
            console.log("r", r.response.data);
          }
        );
      }
      
    },
    passwordEnter() {
      console.log("passwordEnter");
      if (this.errors.any()) {
        return;
      }
      console.log("passwordEnter step 2");
      this.confirm();
    },
    isNumber (evt){
        const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
        const keyPressed = evt.key;
        
        if (!keysAllowed.includes(keyPressed)) {
              evt.preventDefault()
        }
    }
  },
  mounted() {
    const vueThis = this;
    this.form.UserId = this.$route.params.id;
    accountApi.captcha().then(
      ({ data }) => {
        // console.log(data.CaptchaImgUrl);
        // this.from.CaptchaInputText = data.CaptchaInputText;
        vueThis.form.CaptchaImgUrl = data.CaptchaImgUrl;
        vueThis.form.CaptchaId = data.CaptchaId;
        vueThis.form.CaptchaText = data.CaptchaTextValue;
        vueThis.form.CaptchaToken = data.CaptchaTokenValue;

      },
      (r) => {
        vueThis.posting = true;
        console.log("r", r.response.data);
      }
    );

    window.addEventListener("keyup", (event) => {
      if (event.keyCode === 13) {
        // console.log("error", this.errors);
        if (this.errors != null || typeof this.errors != "undefined") {
          return;
        }
        // console.log("no error", "undefined");
        this.confirm();
      }
    });
  },
  watch: {
  timerCount: {
      handler(value) {
          if (value > 0) {
              setTimeout(() => {
                  this.timerCount--;
              }, 1000);
          }
      },
      immediate: true // This ensures the watcher is triggered upon creation
    }
  }
};
</script>

<style scoped>

.side-nav.right-aligned{
  display: none;
}

.classic-form-page {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10000;
  height: 100vh;
  width: 100%;
}

.classic-form-page .view {
  background-image: url("/img/bg-login.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  height: 100vh;
}

.card {
  background-color: rgba(229, 228, 255, 0.2);
}

.classic-form-page h6 {
  line-height: 1.7;
}

.classic-form-page .navbar {
  transition: background 0.5s ease-in-out, padding 0.5s ease-in-out;
}

.classic-form-page .navbar .md-form {
  margin: 0;
}

.top-nav-collapse {
  background: #424f95 !important;
}

@media (max-width: 768px) {
  .classic-form-page .navbar:not(.top-nav-collapse) {
    background: #424f95 !important;
  }
}

.classic-form-page label {
  color: #fff !important;
}
</style>
